<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Uredite stopnjo davka:
    </h2>

    <TaxLevelForm
      @save="save"
      @cancel="cancel"
      :taxLevel="taxLevel"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { loadItem, saveItem } from '@/utils/crudFunctions'
import TaxLevelForm from '@/components/TaxLevelForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    TaxLevelForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  computed: {
    taxLevel () {
      return this.$store.state.taxLevels.items[this.id]
    }
  },
  methods: {
    ...mapActions('taxLevels', ['loadItem', 'saveItem']),
    save ({ data }) {
      saveItem(data, 'MyCompanyTaxLevels', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyTaxLevels' })
    }
  },
  created () {
    loadItem(this)
  }
}
</script>
